import React from 'react'
import './LoadingIndicator.css'

const LoadingIndicator = ({ children }) => (
  <div className="loading-wrap">
    <div className="spinner" />
    {children && <div className="loading-content small">{children}</div>}
  </div>
)

export default LoadingIndicator



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator.js